import _ from "lodash";
import searchLogo from "../assets/images/searchLogo.svg";
import {
  myValueFormatter_quantity,
  rateFormatter,
} from "./commonFunctions";
import { dtcStatusColors , status} from "./constants";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import RecallActivityLink from "../components/RecallActivityLink";
import TickerHyperLinkComponent from "../components/TickerHyperLinkComponent";

export const LoanRecallsColDefs = [
  {
    headerName: "Acc Id",
    field: "accountid",
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return params.values[0];
    },
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 80,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
  },
  {
    headerName: "Cusip",
    field: "sec_id",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 80,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Recall Id",
    field: "recallId",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    hide:true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 80,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Security Name",
    field: "secName",
    floatingFilter: false,
    editable: false,
    hide:true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 200,
    maxWidth: 250,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Ticker",
    field: "ticker",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 70,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    cellRenderer: TickerHyperLinkComponent
  },
  {
    headerName: "Cpty Id",
    field: "cpty_id",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 75,
    maxWidth: 90,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Name",
    field: "cptyName",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    hide:true,
    minWidth: 170,
    maxWidth: 250,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "B/L",
    field: "bl",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 60,
    maxWidth: 70,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Activity Type",
    field: "activity_type",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 110,
    maxWidth: 155,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Contract Id",
    field: "contract_id",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 100,
    maxWidth: 110,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Status",
    field: "status",
    hide:true,
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
        };
      
    },
    minWidth: 70,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "SODQty",
    field: "sod_quantity",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 80,
    maxWidth: 130,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Ln Qty",
    field: "loan_qty",
    aggFunc: "sum",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },

    minWidth: 75,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "RecallQty",
    field: "quantity",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 90,
    maxWidth: 130,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Remaining Qty",
    field: "remaining_qty",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    hide: true,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 90,
    maxWidth: 130,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Rate",
    field: "rate",
    floatingFilter: false,
    filter: "agNumberColumnFilter",
    type: "rightAligned",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
        }
    },
    minWidth: 65,
    maxWidth: 100,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    valueFormatter: rateFormatter
  },
  {
    field: 'isRecall',
    headerName: 'IsRecall',
    pinned: 'right',
    filter: "agSetColumnFilter",
    editable: false,
    minWidth: 70,
    maxWidth: 90,
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    icons: {
      menu: `<img src="${searchLogo}" />`,
    }
  },
  {
    field: 'isFullyRecalled',
    headerName: 'Is Fully Recall',
    pinned: 'right',
    filter: "agSetColumnFilter",
    editable: false,
    hide:true,
    minWidth: 70,
    maxWidth: 90,
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    icons: {
      menu: `<img src="${searchLogo}" />`,
    }
  },
  {
    headerName: "",
    field: "isSelect",
    floatingFilter: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    headerCheckboxSelection: true,
    showDisabledCheckboxes: true,
    checkboxSelection: true,
    editable: false,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    tooltipField: "isFullRecall",
    tooltipComponentParams: function(params: any){
      if(params?.node?.data?.isFullRecall){
        return {
          message: 'Contract is fully recalled',
        };
      }
    },
    pinned: "left",
    lockPinned: true,
    cellClass: "lock-pinned",
    minWidth: 70,
    maxWidth: 90,
    suppressSizeToFit: false,
  },
  
  {
    headerName: "RecallDt",
    field: "recall_date",
    floatingFilter: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return _.max(params.values);
    },
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        
      };
    },
    minWidth: 100,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  
  {
    headerName: "BuyInDate",
    field: "buyin_date",
    floatingFilter: false,
    editable: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return _.max(params.values);
    },
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 100,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "R/T",
    field: "recall_terminate",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 55,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "ReturnQty",
    field: "return_qty",
    aggFunc: "sum",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 95,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  
  {
    headerName: "ReturnDt",
    field: "return_date",
    floatingFilter: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return _.max(params.values);
    },
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 98,
    maxWidth: 105,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Lender Ref Id",
    field: "lender_ref_id",
    floatingFilter: false,
    editable: false,
    hide: false,
    filter: "agSetColumnFilter",
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return _.max(params.values);
    },
    cellRenderer: RecallActivityLink,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 130,
    maxWidth: 185,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "DtcStatus",
    field: "dtc_status",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    pinned: 'right',
    lockPinned: true,
    cellClass: "lock-pinned",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params?.data?.dtc_status?.toLowerCase() === "settled") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: dtcStatusColors.settled
        };
      }
      if (params?.data?.dtc_status?.toLowerCase() === "pended") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.pended
        };
      } if (params?.data?.dtc_status?.toLowerCase() === "rad") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.RAD
        };
      } if (params?.data?.dtc_status?.toLowerCase() === "approved") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.approved
        };
      } if (params?.data?.dtc_status?.toLowerCase() === "reversed") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.reversed
        };
      } if (params?.data?.dtc_status?.toLowerCase() === "dropped") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.dropped
        };
      } if (params?.data?.dtc_status?.toLowerCase() === "non-ccf") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.nonCcf
        };
      } if (params?.data?.dtc_status?.toLowerCase() === "canceled") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.canceled
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
        };
      }
    },
    minWidth: 90,
    maxWidth: 140,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "LnetStatus",
    field: "loanet_status",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    pinned: "right",
    icons: {
      menu: `<img src="${searchLogo}" />`,

    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 95,
    maxWidth: 120,
    cellStyle: function (params: any) {
      if (params?.node?.data?.loanet_status === "Error") {
        return {
          display: "flex",
          alignItems: "center",
          color: "#E90909",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
      else if (params?.node?.data?.loanet_status === "Pending") {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.sent,
        };
      }
       else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
  },
  {
    headerName: "Comments",
    field: "comments",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    pinned: "right",
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    tooltipField: "comments",
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 100,
    maxWidth: 300,
    tooltipComponentParams: function(params: any){
      return {
        message: params?.node?.data?.comments,
      }; 
    },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    resizable: true
  },
  {
    headerName: "Update By",
    field: "updated_by",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 100,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Update Date",
    field: "updatedDate",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 135,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Trader",
    field: "trader",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 100,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Created By",
    field: "created_by",
    floatingFilter: false,
    editable: false,
    hide:true,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 100,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Created Date",
    field: "createdDate",
    floatingFilter: false,
    editable: false,
    hide:true,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 135,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
];